import { refreshCacheKey } from '@shared/cache/cache.browser';
import type { CacheKeyRefresher } from '@tilelist/application/ports/CacheKeyRefresher.ts';

/**
 *
 *
 */
export function createCacheKeyRefresher(): CacheKeyRefresher {
    return {
        refresh: () => refreshCacheKey(),
    };
}
